<template>
  <div
    :key="section"
    class="privacy-page"
    :class="{ 'frame-page': isAgreement || section === 'cancel' }"
  >
    <van-nav-bar
      v-if="!$isWXMiniProgram()"
      :title="title"
      left-arrow
      @click-left="back"
    />
    <div v-if="section === 'settings'" class="settings-content">
      <van-cell-group>
        <van-cell title="账号设置" is-link @click="open('account', true)" />
        <van-cell
          title="个人信息收集清单"
          is-link
          @click="open('collection', true)"
        />
        <van-cell
          title="第三方信息共享清单"
          is-link
          @click="open('third-party')"
        />
        <van-cell title="用户协议" is-link @click="open('agreement')" />
        <van-cell title="隐私政策" is-link @click="open('policy')" />
      </van-cell-group>
      <button class="account-button" @click="loggedIn ? logout() : login()">
        {{ loggedIn ? "退出登录" : "登录账号" }}
      </button>
    </div>
    <div v-else-if="protectedPage && !loggedIn" />
    <div v-else-if="section === 'account'" class="settings-content">
      <van-cell-group>
        <van-cell title="撤销同意《隐私政策》" is-link @click="withdraw" />
        <van-cell title="其他设置" is-link @click="open('other', true)" />
      </van-cell-group>
    </div>
    <div v-else-if="section === 'other'" class="settings-content">
      <van-cell
        class="cancel-entry"
        title="注销账号"
        value="注销后无法恢复，请谨慎操作"
        is-link
        @click="open('cancel', true)"
      />
    </div>
    <div v-else-if="section === 'collection'">
      <p class="intro">
        <van-icon name="warning" class="intro-icon" aria-hidden="true" />
        <span>收票宝将尽全力保护你的个人信息安全，并保障你的个人信息处理中的权限。你可以按照时间周期查询收票宝对你个人信息的收集、处理情况。</span>
      </p>
      <van-cell-group>
        <van-cell title="用户基本信息" is-link @click="detail('basic')" />
        <van-cell title="用户使用过程信息" is-link @click="detail('usage')" />
      </van-cell-group>
    </div>
    <div v-else-if="section === 'detail'" class="collection-detail">
      <van-dropdown-menu active-color="#2979e8">
        <van-dropdown-item v-model="period" :options="periods" @change="loadCollection" />
      </van-dropdown-menu>
      <div v-if="collectionLoading" class="collection-status">正在加载</div>
      <div v-else-if="collectionError" class="collection-status">
        <p>{{ collectionError }}</p>
        <van-button size="small" @click="loadCollection">重新加载</van-button>
      </div>
      <template v-else>
      <section v-for="item in items" :key="item.name" class="collection-group">
        <h3>{{ item.name }}</h3>
        <div class="collection-row">
          <span>使用目的：</span><span class="value">{{ item.purpose }}</span>
        </div>
        <div class="collection-row">
          <span>使用场景：</span><span class="value">{{ item.scenario }}</span>
        </div>
        <div class="collection-row">
          <span>收集情况：</span
          ><span class="value">{{ category === "basic" ? `已收集${collectionCounts[item.itemCode]}条` : item.collectionStatus }}</span>
        </div>
        <div
          class="collection-row"
          :class="{ 'collection-action': item.path || item.optionType }"
          :role="item.path || item.optionType ? 'button' : null"
          :tabindex="item.path || item.optionType ? 0 : null"
          @click="openContent(item)"
          @keydown.enter.prevent="openContent(item)"
        >
          <span>收集内容：</span
          ><span class="value"
            >{{ item.content
            }}<span v-if="item.path || item.optionType" class="content-link"
              >{{ item.linkText }} <van-icon name="arrow" /></span
          ></span>
        </div>
      </section>
      </template>
    </div>
    <ThirdPartyList v-else-if="section === 'third-party'" />
    <iframe
      v-else-if="isAgreement"
      :src="agreementUrls[section]"
      :title="title"
      class="agreement-frame"
    />
    <CancellationFrame
      v-else-if="section === 'cancel'"
      @logout="leaveAccount('cancel')"
    />
  </div>
</template>
<script>
import { NavBar, Cell, CellGroup, DropdownMenu, DropdownItem } from "vant";
import { withdrawConsent, getPersonalInformationCollectionList } from "../../http/api";
import collections from "./collections";
import CancellationFrame from "./CancellationFrame.vue";
import ThirdPartyList from "./ThirdPartyList.vue";
const titles = {
  settings: "设置",
  account: "账号设置",
  other: "其他设置",
  collection: "个人信息收集",
  "third-party": "第三方信息共享清单",
  agreement: "用户协议",
  policy: "隐私政策",
  cancel: "账号注销",
};
export default {
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    CancellationFrame,
    ThirdPartyList,
  },
  data() {
    return {
      agreementUrls: {
        agreement: "https://app1.ningmengyun.com/common/ServiceAgreements.html",
        policy: "https://app1.ningmengyun.com/common/PrivacyPolicy.html",
      },
      period: "7d",
      busy: false,
      collectionCounts: {},
      collectionLoading: false,
      collectionError: "",
      collectionRequestId: 0,
      loggedIn: this.$loginState(),
      periods: [
        { text: "最近7天", value: "7d" },
        { text: "最近30天", value: "30d" },
        { text: "最近1年", value: "1y" },
      ],
    };
  },
  computed: {
    section() {
      return this.$route.params.section;
    },
    category() {
      return this.$route.query.category === "usage" ? "usage" : "basic";
    },
    title() {
      return this.section === "detail"
        ? this.category === "usage"
          ? "用户使用过程信息"
          : "用户基本信息"
        : titles[this.section] || "设置";
    },
    isAgreement() {
      return ["agreement", "policy"].includes(this.section);
    },
    protectedPage() {
      return ["account", "other", "collection", "detail", "cancel"].includes(
        this.section,
      );
    },
    items() {
      return collections[this.category];
    },
  },
  mounted() {
    this.enter();
  },
  watch: {
    $route() {
      this.enter();
    },
  },
  beforeDestroy() {
    this.collectionRequestId++;
  },
  methods: {
    enter() {
      document.title = this.title;
      this.period = "7d";
      this.loggedIn = this.$loginState();
      this.loadCollection();
      if (this.protectedPage && !this.loggedIn) this.login();
    },
    async loadCollection() {
      const requestId = ++this.collectionRequestId;
      this.collectionCounts = {};
      this.collectionError = "";
      this.collectionLoading = false;
      if (this.section !== "detail" || this.category !== "basic" || !this.loggedIn) return;
      this.collectionLoading = true;
      try {
        const result = await getPersonalInformationCollectionList(
          { "7d": 1, "30d": 2, "1y": 3 }[this.period],
        );
        if (requestId !== this.collectionRequestId) return;
        if (!result || result.code !== 1000)
          throw new Error((result && result.msg) || "查询失败，请稍后重试");
        const items = result.data && result.data.items;
        if (!Array.isArray(items)) throw new Error("收集统计数据异常，请稍后重试");
        const counts = {};
        for (const entry of collections.basic) {
          const item = items.find((item) => item && item.itemCode === entry.itemCode);
          if (!item || !Number.isSafeInteger(item.collectionCount) || item.collectionCount < 0)
            throw new Error("收集统计数据异常，请稍后重试");
          counts[entry.itemCode] = item.collectionCount;
        }
        this.collectionCounts = counts;
      } catch (err) {
        if (requestId !== this.collectionRequestId) return;
        if (err && err.response && err.response.status === 401) {
          localStorage.removeItem("token");
          this.loggedIn = false;
          this.login();
        }
        this.collectionError = (err && err.message) || "查询失败，请稍后重试";
      } finally {
        if (requestId === this.collectionRequestId) this.collectionLoading = false;
      }
    },
    back() {
      if (window.history.length > 1) this.$router.back();
      else
        this.$router.replace(
          this.section === "settings" ? "/user" : "/privacy/settings",
        );
    },
    login() {
      this.$wechatMiniProgramToLogin();
    },
    open(section, needsLogin = false) {
      if (needsLogin && !this.$loginState()) {
        this.login();
        return;
      }
      if (this.agreementUrls[section] && this.$isWXMiniProgram()) {
        this.$wechatMiniProgramNavigateTo({
          url: "/pages/website/index?needToken=0&url=" +
            encodeURIComponent(this.agreementUrls[section]),
        });
        return;
      }
      this.$router.push("/privacy/" + section);
    },
    detail(category) {
      this.$router.push({ path: "/privacy/detail", query: { category } });
    },
    openContent(item) {
      if (!this.$loginState()) {
        this.login();
        return;
      }
      if (item.optionType) {
        if (!this.$isWXMiniProgram()) {
          this.$toast("不是微信小程序");
          return;
        }
        // 原生页面返回时会复用当前 H5，提前将列表归位。
        this.$el.scrollTop = 0;
        this.$wechatMiniProgramNavigateTo({
          url: "/pages/options/index?optionType=" +
            item.optionType +
            "&returnToPrevious=1" +
            "&urlToken=" +
            encodeURIComponent(localStorage.getItem("token")),
        });
      } else if (item.path) {
        this.$router.push(item.path);
      }
    },
    async logout() {
      try {
        await this.$dialog.confirm({
          title: "退出登录",
          message: "确定退出当前账号吗？",
        });
      } catch (_) {
        return;
      }
      this.leaveAccount();
    },
    leaveAccount(reason = "logout") {
      localStorage.removeItem("token");
      if (this.$isWXMiniProgram()) {
        this.$wechatMiniProgramNavigateTo({
          url: "/pages/logout/index?reason=" + reason,
        });
      } else {
        this.$router.replace({ name: "home" });
      }
    },
    async withdraw() {
      if (this.busy) return;
      this.busy = true;
      try {
        try {
          await this.$dialog.confirm({
            title: "提示",
            message:
              "撤回后，将不再同意授权隐私协议，并退出当前账号。再次登录时，您需要重新阅读并同意隐私政策后方可继续使用相关服务。",
            confirmButtonText: "撤销",
            cancelButtonText: "取消",
            className: "privacy-withdraw-dialog",
          });
        } catch (_) {
          return;
        }
        const result = await withdrawConsent();
        if (!result.Success || result.Data !== true) {
          this.$toast(result.ErrorMsg || "撤销失败，请稍后重试");
          return;
        }
        this.leaveAccount("withdraw");
      } catch (err) {
        this.loggedIn = this.$loginState();
        if (!this.loggedIn) this.login();
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
<style lang="less">
.privacy-withdraw-dialog {
  .van-dialog__footer {
    flex-direction: row-reverse;
  }
  .van-dialog__confirm::after {
    border-left-width: 0;
    border-right-width: 1px;
  }
}
</style>
<style lang="less" scoped>
.privacy-page {
  height: 100%;
  overflow-y: auto;
  background: #f6f6f6;
  color: #333;
}
.van-nav-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
}
.settings-content {
  padding: 12px 10px;
}
.settings-content .van-cell {
  padding: 16px;
}
.cancel-entry /deep/ .van-cell__title {
  flex: none;
  margin-right: 8px;
}
.cancel-entry /deep/ .van-cell__value {
  font-size: 12px;
  white-space: nowrap;
}
.account-button {
  display: block;
  width: calc(100% - 12px);
  height: 46px;
  margin: 48px 6px;
  border: 1px solid #ddd;
  border-radius: 25px;
  background: #fff;
  color: #333;
  font: inherit;
  font-size: 16px;
}
.intro {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  margin: 0;
  color: #777;
  font-size: 14px;
  line-height: 1.8;
}
.intro-icon {
  flex-shrink: 0;
  margin-right: 6px;
  color: #ffbf00;
  font-size: 16px;
  line-height: inherit;
}
.collection-detail /deep/ .van-dropdown-menu__bar {
  box-shadow: none;
  height: 56px;
}
.collection-detail /deep/ .van-dropdown-menu__item {
  flex: none;
  padding: 0 16px;
}
.collection-group {
  margin-top: 10px;
  background: #fff;
}
.collection-status {
  padding: 40px 24px;
  color: #888;
  text-align: center;
}
h3 {
  margin: 0;
  background: #f2f2f2;
  padding: 9px 16px;
  font-size: 16px;
  font-weight: 500;
}
.collection-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 10px 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  line-height: 22px;
}
.collection-row > span:first-child {
  flex-shrink: 0;
}
.value {
  flex: 1;
  min-width: 0;
  text-align: right;
  color: #999;
  overflow-wrap: anywhere;
}
.collection-action {
  cursor: pointer;
}
.collection-action .value {
  color: #508bca;
}
.content-link {
  display: block;
  width: 100%;
  margin-top: 4px;
  text-align: right;
  background: none;
  border: 0;
  color: #508bca;
  font: inherit;
}
.frame-page {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.agreement-frame {
  flex: 1;
  min-height: 0;
  width: 100%;
  border: 0;
  background: #fff;
}
</style>
